module.exports = __webpack_public_path__ + "img/warning.24a700bb.png";